import { Link } from 'react-router-dom';
import '../styles/footer.css';

interface FooterLink {
  to: string;
  label: string;
  external?: boolean;
}

const FOOTER_LINKS: FooterLink[] = [
  { to: '/trace', label: '溯源查询' },
  { to: '/market', label: '市场行情' },
  { to: 'https://trade.yunniuji.com', label: '交易市场', external: true },
  { to: 'https://transport.yunniuji.com', label: '监管平台', external: true },
  { to: '/solutions', label: '解决方案' },
  { to: '/about', label: '关于我们' },
  { to: '/contact', label: '联系我们' },
];

/** 页脚版权年份，随当前年份自动更新，避免手写年份与实际年份脱节 */
const COPYRIGHT_YEAR = new Date().getFullYear();

/** 工信部 ICP 备案号，境内网站依法必须在页脚公示，并链接至官方查询站 */
const ICP_FILING = '鄂ICP备15009094号-15';
const ICP_QUERY_URL = 'https://beian.miit.gov.cn/';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <img
            src="/logo.svg"
            onError={(e) => { (e.target as HTMLImageElement).src = "/logo.png"; }}
            alt="云牛集"
            className="brand-mark"
          />
          <div>
            <strong>云牛集</strong>
            <p>山东牛产业智慧平台 — 连接肉牛产业链上下游</p>
          </div>
        </div>
        <nav className="footer-links" aria-label="页脚导航">
          {FOOTER_LINKS.map((item) =>
            item.external ? (
              <a key={item.to} href={item.to} target="_blank" rel="noreferrer">
                {item.label}
              </a>
            ) : (
              <Link key={item.to} to={item.to}>
                {item.label}
              </Link>
            )
          )}
        </nav>
      </div>
      <div className="footer-bar">
        <div className="container footer-bar-inner">
          <div className="footer-meta">
            <span>运营主体：武汉高灏科技有限责任公司</span>
            <span>
              业务咨询请通过
              <Link to="/contact" className="footer-meta-link">
                联系我们
              </Link>
              提交
            </span>
            <a
              className="footer-beian"
              href={ICP_QUERY_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              {ICP_FILING}
            </a>
          </div>
          <span>© {COPYRIGHT_YEAR} 云牛集</span>
        </div>
      </div>
    </footer>
  );
}
